import template from './employee_notifications.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeNotificationsViewModel
{
	constructor(page)
	{
		this.page = page;
		this.notifications = ko.observableArray([]);
		this.employee_id = ko.observable();
	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	async show_notification(data)
	{
		let notif_data = ko.toJS(data);
		await Grape.dialog.open('OpenNotification', { data: notif_data });
		this.page.updateData();
	}

	mark_notification(v, e)
	{
		if ($(e.currentTarget).parent().hasClass('notification_selected'))
			$(e.currentTarget).parent().removeClass('notification_selected');
		else
			$(e.currentTarget).parent().addClass('notification_selected');
	}

	mark_all_notifications()
	{
		if ($('.notification_holder').hasClass('notification_selected'))
			$('.notification_holder').removeClass('notification_selected');
		else
			$('.notification_holder').addClass('notification_selected');
	}

	refresh()
	{
		this.page.updateData();
	}

	async mark_selected_read()
	{
		let selected_ids = new Array();
		$('.notification_holder').each(function () {
			if ($(this).hasClass('notification_selected'))
				selected_ids.push(Number($(this).attr('id')));
		});

		// UPDATE READ STATUS
		if (selected_ids.length > 0)
		{
			await Grape.fetches.postJSON('/notifications/read_receipt_notification', { employee_id: this.employee_id(), notifications_ids: selected_ids });
			this.page.updateData();
		}
	};

	async delete_selected()
	{
		let selected_ids = new Array();
		$('.notification_holder').each(function () {
			if ($(this).hasClass('notification_selected'))
				selected_ids.push(Number($(this).attr('id')));
		});

		// UPDATE READ STATUS
		if (selected_ids.length > 0)
		{
			await Grape.fetches.postJSON('/notifications/delete_notification', { employee_id: this.employee_id(), notifications_ids: selected_ids });
			this.page.updateData();
		}
	};
}

class EmployeeNotifications
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeNotificationsViewModel(this);
		let employee_id = Utils.get_local_storage_nullable('employee_id');
		if (employee_id == null || employee_id == 0)
			employee_id = 0;

		this.viewModel.employee_id(employee_id);
	}

	async init()
	{
		document.title = tr('Notifications');
		window.current_page_title(tr('Notifications'));
	}

	async updateData()
	{
		this.viewModel.notifications.removeAll();

		let result = await Grape.fetches.postJSON('/notifications/get_notifications', { employee_id: this.viewModel.employee_id() });
		if (result.notifications != null)
		{
			for (let i = 0; i < result.notifications.length; i++)
			{
				let employee = result.notifications[i].recipients.filter(recipient => recipient.employee_id == this.viewModel.employee_id());
				if (employee.length > 0)
					result.notifications[i].is_read = employee[0].notifications_status == 'Read';

				this.viewModel.notifications.push(result.notifications[i]);
			}
		}
	}
}

export default {
	route: '[/]employee/notifications',
	page_class: EmployeeNotifications,
	template: template,
	template_filename: 'translation/employee_notifications'
};
